class PokemonType {
	constructor(data) {
		this.name = data.type.name
	}
}

export default PokemonType
